var map = {
	"./pmcariacica/icons/favicon/favicon.png": 84904,
	"./pmci/icons/favicon/favicon.png": 73340,
	"./pmv/icons/favicon/favicon.png": 2674,
	"./pmvv/icons/favicon/favicon.png": 47680,
	"./upcities/icons/favicon/favicon.png": 94011
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90268;